export enum HTTPMethod {
  CONNECT = "CONNECT",
  DELETE = "DELETE",
  GET = "GET",
  HEAD = "HEAD",
  OPTIONS = "OPTIONS",
  PATCH = "PATCH",
  POST = "POST",
  PUT = "PUT",
  TRACE = "TRACE",
}

export enum LogLevel {
  error = "error",
  warn = "warn",
  info = "info",
  debug = "debug",
}

export type LogLine = Record<string, string>;

export type Batch = { level: LogLevel; logs: [string, string][] }[];

export type FetchOperation = {
  method: HTTPMethod;
  url: URL | undefined;
  duration?: number;
  userId?: number;
};
